import ReactPixel from "react-facebook-pixel";
import ReactGA from "react-ga";

// ## DISCLAIMER: Don"t forget to change the values below on the checkout-page as well
const facebookPixelId = "1823058091043992";
const googleAnalyticsId = "UA-54149473-1";

export const initPixels = () => {
    ReactPixel.init(facebookPixelId, {}, {
        autoConfig: true,
        debug: false
    });
    ReactPixel.pageView();

    ReactGA.initialize(googleAnalyticsId);
    ReactGA.ga("require", "ecommerce");
    ReactGA.ga("send", "pageview");
}

export const RegisterPageView = () => {
    ReactPixel.pageView();
    ReactGA.ga("send", "pageview");
}

export const RegisterProductView = (productId, product) => {
    ReactPixel.track("ViewContent", {
        content_type: "product",
        content_ids: productId
    });

    // Klaviyo
   var _learnq = window._learnq || [];
    _learnq.push(["track", "Viewed Product", {
        "ProductName": product.title,
        "ProductID": product.id.toString(),
        "SKU": product.id.toString(),
        "Categories": product.categories.map(item => {
            return item.name
        }),
        "ImageURL": product.mainImageSrc,
        "URL": window.document.URL,
        "Price": parseInt(product.variations[0].price),
        "CompareAtPrice": parseInt(product.variations[0].price)
    }]);
}

export const RegisterAddToCart = (productId) => {
    ReactPixel.track("AddToCart", {
        content_ids: productId
    });
}

export const RegisterPurchase = (value, currency, content_ids, order_id) => {
    ReactPixel.track("Purchase", {
        value,
        currency,
        content_ids
    });

    ReactGA.ga("ecommerce:addTransaction", {
        "id": order_id,
        "revenue": value,
        "currency": currency
    });
    ReactGA.ga("ecommerce:send");
}

// export const RegisterCategoryView = (categoryId, categoryName) => {
//     ReactPixel.track("ViewCategory", {
//         content_type: "product_group",
//         content_ids: categoryId,
//         content_name: categoryName
//     });
// }